import React from 'react';
import {createPortal} from 'react-dom';
import {usePortalElement} from '../../../hooks/usePortalElement/usePortalElement';

export const RenderInPortal: React.FC<
  React.PropsWithChildren<{
    portalId: string;
  }>
> = ({children, portalId}) => {
  const flyoutPortalElement = usePortalElement(portalId);

  if (!flyoutPortalElement) {
    return null;
  }

  return createPortal(<>{children}</>, flyoutPortalElement);
};
